import mongoose from "mongoose";

export interface MessageLink {
  description: string;
  link: string;
}

export interface Message {
  _id: mongoose.Schema.Types.ObjectId;
  mainMessage: string;
  detailedMessage?: string;
  createdDate: Date;
  expiryDate?: Date;
  customerId: string;
  fileName?: string;
  /** @deprecated */ filePath?: string;
  sdmDocument?: mongoose.Schema.Types.ObjectId;
  messageLinks?: MessageLink[];
  eventStart?: Date;
  eventEnd?: Date;
  /** @deprecated */ eventStartDate?: string;
  /** @deprecated */ eventEndDate?: string;
  /** @deprecated */ eventStartTime?: string;
  /** @deprecated */ eventEndTime?: string;
  /** @deprecated */ allDayEvent?: boolean;
  eventLocation?: string;
  isEvent?: boolean;
}

export const MessageSchema = new mongoose.Schema<Message>({
  mainMessage: String,
  detailedMessage: String,
  createdDate: Date,
  expiryDate: { type: Date, expires: 0 },
  customerId: String,
  fileName: String,
  sdmDocument: mongoose.Schema.Types.ObjectId,
  messageLinks: [{
    _id: false,
    description: String,
    link: String,
  }],
  isEvent: { type: Boolean, default: false },
  eventStart: String,
  eventEnd: String,
  eventLocation: String,
  eventStartDate: String,
  eventEndDate: String,
  eventStartTime: String,
  eventEndTime: String,
  allDayEvent: { type: Boolean, default: false },
  filePath: String,
});
